module.exports = __webpack_public_path__ + "static/media/blackFourSquaresIcon.a09c00d7.svg";